import { Link } from "react-router-dom";

const socialList = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

const quickLinks = [
  { label: "电影资讯", to: "/category?category=movie" },
  { label: "电视剧资讯", to: "/category?category=tv" },
  { label: "综艺资讯", to: "/category?category=variety" },
  { label: "搜索", to: "/search" },
];

const specialLinks = [
  { label: "电影专题", to: "/special/movie" },
  { label: "电视剧专题", to: "/special/tv" },
  { label: "综艺专题", to: "/special/variety" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-primary-900/40 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-movie-2-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-2xl font-black text-background-50">羞羞</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/80">
              羞羞是综合影视娱乐门户，聚合电影、电视剧与综艺资讯，做你身边的影视情报站。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {socialList.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  title={s.label}
                  aria-label={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={`${s.icon} text-base`} aria-hidden="true" />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/category" className="transition-colors hover:text-accent-400">
                内容导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/special/movie" className="transition-colors hover:text-accent-400">
                精选专题
              </Link>
            </h4>
            <ul className="mt-4 space-y-3">
              {specialLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/about" className="transition-colors hover:text-accent-400">
                联系我们
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" aria-hidden="true" />
                hello@xiuxiu-media.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base text-accent-400" aria-hidden="true" />
                北京市朝阳区影视文化产业园
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-accent-400" aria-hidden="true" />
                周一至周五 9:00 - 18:00
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-200/70 md:flex-row md:px-8">
          <p>© 2026 羞羞影视娱乐平台 · 本站内容仅作影视资讯展示与交流，不提供在线播放与下载服务。</p>
          <p>用心整理每一部好作品</p>
        </div>
      </div>
    </footer>
  );
}